import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import queryString from "query-string";
import validateQueryParams from "../helpers/validateQueryParams";

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const queryParams = queryString.parse(location.search);
  const { error } = validateQueryParams(queryParams);

  return error ? <Navigate to="/unauthorized" state={{ from: location }} /> : children;
};

export default PrivateRoute;
